import React from 'react';

const FixedFooter = () => {
  return(
    <footer className="fixed flex">
      <a href="https://www.cs.washington.edu/" target="_blank" rel="noreferrer">
        <img id="cse-logo" src="img/cse-logo.png" alt="Link to UW CSE" />
      </a>
      <p>
        Copyright © 2020 UW CSE/ECE 475
      </p>
      <a href="https://www.ece.uw.edu/" target="_blank" rel="noreferrer">
        <img id="ece-logo" src="img/ece-logo.png" alt="Link to UW ECE" />
      </a>
    </footer>
  )
}

export default FixedFooter;
